<div class="form-container mat-elevation-z8">
  <div>
    <mat-form-field appearance="outline" fxFlex="45%">
      <mat-label>Report Type</mat-label>
      <mat-select placeholder="Select report type" [(ngModel)]="reportType">
        <mat-option value="residential">Residential</mat-option>
        <mat-option value="commercial">Commercial</mat-option>
        <mat-option value="industrial">Industrial</mat-option>
        <!-- Additional options -->
      </mat-select>
    </mat-form-field>
  </div>
  <div class="form-group" fxLayout="row" fxLayoutGap="10px">
    <div style="width: 27%;">
      <h3>Approaches</h3>
      <div class="approaches-container">
        <mat-checkbox fxFlex="100%" [(ngModel)]="approaches.salesComparison">Sales Comparison</mat-checkbox>
        <mat-checkbox fxFlex="100%" [(ngModel)]="approaches.incomeCapDirect">Income Capitalization - Direct
          Cap</mat-checkbox>
        <mat-checkbox fxFlex="100%" [(ngModel)]="approaches.incomeCapDiscounted">Income Capitalization - Discounted
          Cash
          Flow</mat-checkbox>
        <mat-checkbox fxFlex="100%" [(ngModel)]="approaches.costApproach">Cost Approach</mat-checkbox>
        <mat-checkbox fxFlex="100%" [(ngModel)]="approaches.insurableValue">Insurable Value</mat-checkbox>
        <mat-checkbox fxFlex="100%" [(ngModel)]="approaches.actualCashValue">Actual Cash Value</mat-checkbox>
        <mat-checkbox fxFlex="100%" [(ngModel)]="approaches.liquidationValue">Liquidation Value</mat-checkbox>
        <mat-checkbox fxFlex="100%" [(ngModel)]="approaches.dispositionValue">Disposition Value</mat-checkbox>
        <mat-checkbox fxFlex="100%" [(ngModel)]="approaches.businessValue">Business Value</mat-checkbox>
      </div>
    </div>
    <div style="width: 70%;">
      <h3>Scenarios</h3>
      <table mat-table [dataSource]="scenarios" class="mat-elevation-z8">
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> Type </th>
          <td mat-cell *matCellDef="let element"> {{element.type}} </td>
        </ng-container>
        <ng-container matColumnDef="premise">
          <th mat-header-cell *matHeaderCellDef> Premise </th>
          <td mat-cell *matCellDef="let element"> {{element.premise}} </td>
        </ng-container>
        <ng-container matColumnDef="interest">
          <th mat-header-cell *matHeaderCellDef> Interest </th>
          <td mat-cell *matCellDef="let element"> {{element.interest}} </td>
        </ng-container>
        <ng-container matColumnDef="timing">
          <th mat-header-cell *matHeaderCellDef> Timing </th>
          <td mat-cell *matCellDef="let element"> {{element.timing}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>